export const services = [
  {
    name: "Home",
    ref: "mainInfo",
  },
  {
    name: "Kundenstimmen",
    ref: "testimonials",
  },
  {
    name: "Vorgehensweise",
    ref: "success",
  },
  {
    name: "Das Team",
    ref: "team",
  },
];
